export default {
  "title": "QuickBox Support",
  "description": "Enable temporary support access for QuickBox staff to assist with your server.",
  "supportAccess": "Support Access:",
  "enabled": "Enabled",
  "disabled": "Disabled",
  "unknown": "Unknown",
  "important": "Important:",
  "securityNotice": "The support account is automatically disabled after 24 hours for security.",
  "enable": "Enable Support",
  "enabling": "Enabling...",
  "disable": "Disable Support",
  "disabling": "Disabling...",
  "check": "Check Status",
  "checking": "Checking...",
  "running": "Running",
  "completed": "Completed",
  "failed": "Failed",
  "idle": "Idle",
  "clearConsole": "Clear console",
  "output": "Command output",
  "awaitingInput": "Awaiting input",
  "awaitingHint": "Click a button above to run a support command",
  "templateTitle": "Support Request Template",
  "copied": "Copied!",
  "copyTemplate": "Copy template",
  "templateHint": "Run “Enable Support” to auto-fill server details",
  "copy": "Copy",
  "resources": "Support Resources",
  "resourcesDescription": "Helpful links for getting support.",
  "documentation": "Documentation",
  "documentationDescription": "Browse the QuickBox docs",
  "community": "Support & Discord",
  "communityDescription": "Get help from the community",
  "completedLine": "command completed successfully",
  "failedLine": "command failed with exit code {{exitCode}}",
  "connectionLost": "connection to server lost",
  "errorLine": "error: {{message}}",
  "enabledToast": "Support access enabled",
  "disabledToast": "Support access disabled",
  "commandFailed": "Command failed",
  "copiedToast": "Support template copied to clipboard",
  "copyFailed": "Failed to copy template",
  "startFailed": "Failed to start job",
  "unknownError": "Unknown error",
  "forbidden": "Admin privileges required.",
  "invalidAction": "Invalid support action.",
  "alreadyRunning": "A support operation is already in progress."
} as const;
